import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Icon from '@comp/Icon.vue';
import SelectInput from '@comp/forms/inputs/SelectInput.vue';
import WinningsProfit from '@comp/parts/user-page/WinningProfit.vue';
import Statistics from '@comp/parts/user-page/Statistics.vue';
import VButton from '@comp/parts/VButton.vue';
import CalerndarIcon from '!!url-loader?!@static/icons/s-calendar.svg';
import FilterIcon from '!!url-loader?!@static/icons/s-filter.svg';
import DollarIcon from '!!url-loader?!@static/icons/s-dollar.svg';
import ShieldIcon from '!!url-loader?!@static/icons/s-shield.svg';
import CheckIcon from '!!url-loader?!@static/icons/s-check.svg';
import AllIcon from '!!url-loader?!@static/icons/s-squares.svg';
import SpreadIcon from '!!url-loader?!@static/icons/s-spread.svg';
import MoneylineIcon from '!!url-loader?!@static/icons/s-moneyline.svg';
import TotalIcon from '!!url-loader?!@static/icons/s-total.svg';
import ParlayIcon from '!!url-loader?!@static/icons/s-parlay.svg';
import { VMenu, VSlideYTransition, VTextField, VDatePicker } from 'vuetify/lib';
import moment from 'moment';
import { profileClient } from '@api/profile';
import LeagueAll from '!!url-loader?!@static/icons/league-all.svg';
export default {
  name: 'UserStatistic',
  components: {
    Icon: Icon,
    SelectInput: SelectInput,
    'v-menu': VMenu,
    'v-text-field': VTextField,
    'v-date-picker': VDatePicker,
    WinningsProfit: WinningsProfit,
    Statistics: Statistics,
    VButton: VButton
  },
  props: {
    userName: String
  },
  data: function data() {
    return {
      CalerndarIcon: CalerndarIcon,
      FilterIcon: FilterIcon,
      ParlayIcon: ParlayIcon,
      filterIsOpen: false,
      parlaysOnly: false,
      pickType: undefined,
      wagerType: undefined,
      parlaysOnlyState: false,
      pickTypeState: undefined,
      wagerTypeState: undefined,
      period: '',
      timeList: [],
      wagerTypes: [{
        icon: AllIcon,
        value: undefined,
        title: 'All'
      }, {
        icon: SpreadIcon,
        value: 'spread',
        title: 'Spread'
      }, {
        icon: MoneylineIcon,
        value: 'moneyLine',
        title: 'Moneyline'
      }, {
        icon: TotalIcon,
        value: 'total',
        title: 'Total'
      }],
      pickTypes: [{
        title: 'All',
        value: undefined,
        tooltip: ''
      }, {
        icon: DollarIcon,
        value: 'paid',
        tooltip: 'Paid Pick'
      }, {
        icon: ShieldIcon,
        value: 'guaranteed',
        tooltip: 'Guaranteed Pick'
      }, {
        icon: CheckIcon,
        value: 'free',
        tooltip: 'Free Pick'
      }],
      dateFrom: '',
      dateTo: '',
      dateFromModal: false,
      dateToModal: false,
      maxDate: moment().format('YYYY-MM-DD'),
      // Statistic Data
      periodLabel: '',
      statisticInfo: [],
      statisticOverall: {
        periodTime: [{
          type: 'record',
          val: '0-0-0',
          status: 'none'
        }, {
          type: 'pers',
          val: 0,
          status: 'none'
        }, {
          type: 'roi',
          val: 0,
          status: 'none'
        }, {
          type: 'winnings',
          val: 0,
          status: 'none'
        }],
        allTime: [{
          type: 'record',
          val: '0-0-0',
          status: 'none'
        }, {
          type: 'pers',
          val: 0,
          status: 'none'
        }, {
          type: 'roi',
          val: 0,
          status: 'none'
        }, {
          type: 'winnings',
          val: 0,
          status: 'none'
        }]
      },
      noLeagueStatictics: {
        periodTime: [{
          type: 'record',
          val: '0-0-0',
          status: 'none'
        }, {
          type: 'pers',
          val: 0,
          status: 'none'
        }, {
          type: 'roi',
          val: 0,
          status: 'none'
        }, {
          type: 'winnings',
          val: 0,
          status: 'none'
        }],
        allTime: [{
          type: 'record',
          val: '0-0-0',
          status: 'none'
        }, {
          type: 'pers',
          val: 0,
          status: 'none'
        }, {
          type: 'roi',
          val: 0,
          status: 'none'
        }, {
          type: 'winnings',
          val: 0,
          status: 'none'
        }]
      },
      hasNoLeagueStatictics: false,
      statisticOverallWygerType: null,
      // Profit Data
      chartDates: [],
      chartSeries: [],
      leagues: [],
      leagueSelected: '',
      LeagueAll: LeagueAll
    };
  },
  watch: {
    userName: function userName() {
      this.fetchResultativePeriod();
    },
    period: function period(val) {
      switch (val) {
        case 'Past_week':
          {
            var dateFrom = new Date().setDate(new Date().getDate() - 7);
            this.dateFrom = new Date(dateFrom).toISOString().substr(0, 10);
            this.dateTo = new Date().toISOString().substr(0, 10);
          }
          break;

        case 'Past_month':
          {
            var month = new Date().getMonth();

            var _dateFrom = new Date().setMonth(month - 1);

            this.dateFrom = new Date(_dateFrom).toISOString().substr(0, 10);
            this.dateTo = new Date().toISOString().substr(0, 10);
          }
          break;

        case 'Past_3_months':
          {
            var _month = new Date().getMonth();

            var _dateFrom2 = new Date().setMonth(_month - 3);

            this.dateFrom = new Date(_dateFrom2).toISOString().substr(0, 10);
            this.dateTo = new Date().toISOString().substr(0, 10);
          }
          break;

        case 'Past_6_months':
          {
            var _month2 = new Date().getMonth();

            var _dateFrom3 = new Date().setMonth(_month2 - 6);

            this.dateFrom = new Date(_dateFrom3).toISOString().substr(0, 10);
            this.dateTo = new Date().toISOString().substr(0, 10);
          }
          break;

        case 'Past_year':
          {
            var year = new Date().getFullYear();

            var _dateFrom4 = new Date().setFullYear(year - 1);

            this.dateFrom = new Date(_dateFrom4).toISOString().substr(0, 10);
            this.dateTo = new Date().toISOString().substr(0, 10);
          }
          break;

        case 'All_time':
          {
            this.dateFrom = '';
            this.dateTo = '';
          }
          break;
      }

      if (val) {
        this.periodLabel = this.timeList.find(function (z) {
          return z.value === val;
        }).title;
        this.fetchData();
      }
    }
  },
  computed: {
    leagueList: function leagueList() {
      if (this.hasNoLeagueStatictics && this.noLeagueStatictics) {
        return [{
          value: '',
          title: 'All Leagues',
          shortTitle: 'All',
          icon: LeagueAll
        }, {
          value: 'parlays_multiple',
          title: 'Parlay - Multiple Leagues',
          shortTitle: 'Parlay',
          icon: ParlayIcon
        }].concat(_toConsumableArray(this.leagues));
      } else {
        return [{
          value: '',
          title: 'All Leagues',
          shortTitle: 'All',
          icon: LeagueAll
        }].concat(_toConsumableArray(this.leagues));
      }
    },
    leagueSelectedTitle: function leagueSelectedTitle() {
      var _this = this;

      var league = this.leagueList.find(function (z) {
        return z.value === _this.leagueSelected;
      });
      return league ? league.title : '';
    },
    computedDateFrom: function computedDateFrom() {
      return this.dateFrom ? moment(this.dateFrom).format('ll') : '';
    },
    computedDateTo: function computedDateTo() {
      return this.dateTo ? moment(this.dateTo).format('ll') : '';
    },
    filtersCount: function filtersCount() {
      var n = 0;
      if (this.pickTypeState) n++;
      if (this.wagerTypeState) n++;
      if (this.parlaysOnlyState) n++;
      return n;
    }
  },
  methods: {
    changeDate: function changeDate() {
      this.period = '';
      this.periodLabel = "From ".concat(moment(this.dateFrom).format('MMM D YYYY'), " To ").concat(moment(this.dateTo).format('MMM D YYYY'));
      this.fetchData();
    },
    changeLeague: function changeLeague(val) {
      this.leagueSelected = val;
      this.fetchProfitData();
    },
    fetchStatisticData: function fetchStatisticData() {
      var _this2 = this;

      var options = {
        from: this.dateFrom ? moment(this.dateFrom).toDate() : undefined,
        to: this.dateTo ? moment(this.dateTo).add(1, 'days').toDate() : undefined,
        username: this.userName,
        parlaysOnly: this.parlaysOnlyState,
        wagerType: this.wagerTypeState,
        pickPaymentType: this.pickTypeState
      };
      profileClient.leaguesStats(options).then(function (resp) {
        var getPercent = function getPercent(win, lose) {
          if (win === 0 || win === 0 && lose === 0) {
            return 0;
          }

          return Math.round(win / (win + lose) * 100);
        };

        var geStatus = function geStatus(val_1, val_2) {
          return val_1 > val_2 ? 'up' : val_1 < val_2 ? 'down' : 'none';
        }; // Overall period summary


        var overallPeriodWin = 0;
        var overallPeriodlose = 0;
        var overallPeriodPush = 0;
        var overallPeriodProfit = 0; // let overallPeriodRoi = 0;
        // Overall all summary

        var overallAllWin = 0;
        var overallAlllose = 0;
        var overallAllPush = 0;
        var overallAllProfit = 0; // let overallAllRoi = 0;
        // leagues list

        var leagues = [];
        _this2.statisticInfo = resp.items.map(function (data) {
          // Period summary
          var periodWin = 0;
          var periodlose = 0;
          var periodPush = 0;
          var periodProfit = 0; // All summary

          var allWin = 0;
          var alllose = 0;
          var allPush = 0;
          var allProfit = 0; // WagerType statistic

          var list = data.overallStatistics.map(function (z) {
            var periodStatistic = _this2.period === 'All_time' ? _objectSpread({}, z) : data.periodStatistics.find(function (x) {
              return x.wagerType === z.wagerType;
            }); // Period summary

            if (periodStatistic !== undefined) {
              periodWin += periodStatistic.win;
              periodlose += periodStatistic.lose;
              periodPush += periodStatistic.push;
              periodProfit += periodStatistic.profit;
            } // All summary


            allWin += z.win;
            alllose += z.lose;
            allPush += z.push;
            allProfit += z.profit;
            return {
              title: _this2.wagerTypes.find(function (x) {
                return x.value === z.wagerType;
              }).title,
              key: _this2.wagerTypes.find(function (x) {
                return x.value === z.wagerType;
              }).value,
              periodTime: [{
                type: 'record',
                val: periodStatistic ? "".concat(periodStatistic.win, "-").concat(periodStatistic.lose, "-").concat(periodStatistic.push) : "0-0-0",
                status: periodStatistic ? geStatus(periodStatistic.win, periodStatistic.lose) : 'none'
              }, {
                type: 'pers',
                val: periodStatistic ? getPercent(periodStatistic.win, periodStatistic.lose) : 0,
                status: periodStatistic ? geStatus(getPercent(periodStatistic.win, periodStatistic.lose), periodStatistic.win || periodStatistic.lose ? 50 : 0) : 'none'
              }, {
                type: 'roi',
                val: periodStatistic ? periodStatistic.roi * 100 : 0,
                status: periodStatistic ? geStatus(periodStatistic.roi * 100, 0) : 'none'
              }, {
                type: 'winnings',
                val: periodStatistic ? periodStatistic.profit : 0,
                status: periodStatistic ? geStatus(periodStatistic.profit, 0) : 'none'
              }],
              allTime: [{
                type: 'record',
                val: "".concat(z.win, "-").concat(z.lose, "-").concat(z.push),
                status: geStatus(z.win, z.lose)
              }, {
                type: 'pers',
                val: getPercent(z.win, z.lose),
                status: geStatus(getPercent(z.win, z.lose), z.win || z.lose ? 50 : 0)
              }, {
                type: 'roi',
                val: z.roi * 100,
                status: geStatus(z.roi * 100, 0)
              }, {
                type: 'winnings',
                val: z.profit,
                status: geStatus(z.profit, 0)
              }]
            };
          }); // Parlay statistic

          if (data.overallParlayStatictics) {
            var _overallParlayStatictics = data.overallParlayStatictics;
            var _periodParlayStatictics = data.periodParlayStatictics; // Period summary

            if (_periodParlayStatictics) {
              periodWin += _periodParlayStatictics.win;
              periodlose += _periodParlayStatictics.lose;
              periodPush += _periodParlayStatictics.push;
              periodProfit += _periodParlayStatictics.profit;
            } // All summary


            allWin += _overallParlayStatictics.win;
            alllose += _overallParlayStatictics.lose;
            allPush += _overallParlayStatictics.push;
            allProfit += _overallParlayStatictics.profit;
            list.push({
              title: 'Parlay',
              key: 'parlay',
              periodTime: [{
                type: 'record',
                val: _periodParlayStatictics ? "".concat(_periodParlayStatictics.win, "-").concat(_periodParlayStatictics.lose, "-").concat(_periodParlayStatictics.push) : "0-0-0",
                status: _periodParlayStatictics ? geStatus(_periodParlayStatictics.win, _periodParlayStatictics.lose) : 'none'
              }, {
                type: 'pers',
                val: _periodParlayStatictics ? getPercent(_periodParlayStatictics.win, _periodParlayStatictics.lose) : 0,
                status: _periodParlayStatictics ? geStatus(getPercent(_periodParlayStatictics.win, _periodParlayStatictics.lose), _periodParlayStatictics.win || _periodParlayStatictics.lose ? 50 : 0) : 'none'
              }, {
                type: 'roi',
                val: _periodParlayStatictics ? _periodParlayStatictics.roi * 100 : 0,
                status: _periodParlayStatictics ? geStatus(_periodParlayStatictics.roi * 100, 0) : 'none'
              }, {
                type: 'winnings',
                val: _periodParlayStatictics ? _periodParlayStatictics.profit : 0,
                status: _periodParlayStatictics ? geStatus(_periodParlayStatictics.profit, 0) : 'none'
              }],
              allTime: [{
                type: 'record',
                val: "".concat(_overallParlayStatictics.win, "-").concat(_overallParlayStatictics.lose, "-").concat(_overallParlayStatictics.push),
                status: geStatus(_overallParlayStatictics.win, _overallParlayStatictics.lose)
              }, {
                type: 'pers',
                val: getPercent(_overallParlayStatictics.win, _overallParlayStatictics.lose),
                status: geStatus(getPercent(_overallParlayStatictics.win, _overallParlayStatictics.lose), _overallParlayStatictics.win || _overallParlayStatictics.lose ? 50 : 0)
              }, {
                type: 'roi',
                val: _overallParlayStatictics.roi * 100,
                status: geStatus(_overallParlayStatictics.roi * 100, 0)
              }, {
                type: 'winnings',
                val: _overallParlayStatictics.profit,
                status: geStatus(_overallParlayStatictics.profit, 0)
              }]
            });
          } // Overall period summary


          overallPeriodWin += periodWin;
          overallPeriodlose += periodlose;
          overallPeriodPush += periodPush;
          overallPeriodProfit += periodProfit; // overallPeriodRoi +=
          //   this.period === 'All_time'
          //     ? data.alltimeROI * 100
          //     : data.roi * 100;
          // Overall all summary

          overallAllWin += allWin;
          overallAlllose += alllose;
          overallAllPush += allPush;
          overallAllProfit += allProfit; // overallAllRoi += data.alltimeROI * 100;
          // leagues list

          leagues.push({
            value: data.leagueCode,
            title: data.league,
            shortTitle: data.leagueAcronym,
            icon: data.imageUrl
          });
          return {
            icon: data.imageUrl,
            title: data.league,
            code: data.leagueCode,
            open: false,
            periodTime: [{
              type: 'record',
              val: "".concat(periodWin, "-").concat(periodlose, "-").concat(periodPush),
              status: geStatus(periodWin, periodlose)
            }, {
              type: 'pers',
              val: getPercent(periodWin, periodlose),
              status: geStatus(getPercent(periodWin, periodlose), periodWin || periodlose ? 50 : 0)
            }, {
              type: 'roi',
              val: _this2.period === 'All_time' ? data.alltimeROI * 100 : data.roi * 100,
              status: _this2.period === 'All_time' ? geStatus(data.alltimeROI * 100, 0) : geStatus(data.roi * 100, 0)
            }, {
              type: 'winnings',
              val: periodProfit,
              status: geStatus(periodProfit, 0)
            }],
            allTime: [{
              type: 'record',
              val: "".concat(allWin, "-").concat(alllose, "-").concat(allPush),
              status: geStatus(allWin, alllose)
            }, {
              type: 'pers',
              val: getPercent(allWin, alllose),
              status: geStatus(getPercent(allWin, alllose), allWin || alllose ? 50 : 0)
            }, {
              type: 'roi',
              val: data.alltimeROI * 100,
              status: geStatus(data.alltimeROI * 100, 0)
            }, {
              type: 'winnings',
              val: allProfit,
              status: geStatus(allProfit, 0)
            }],
            list: list
          };
        }); // Check parlay no League statistc

        var periodParlayNoLeagueStatictics = resp.periodParlayNoLeagueStatictics;
        var overallParlayNoLeagueStatictics = resp.overallParlayNoLeagueStatictics;

        if (periodParlayNoLeagueStatictics) {
          overallPeriodWin += periodParlayNoLeagueStatictics.win;
          overallPeriodlose += periodParlayNoLeagueStatictics.lose;
          overallPeriodPush += periodParlayNoLeagueStatictics.push;
          overallPeriodProfit += periodParlayNoLeagueStatictics.profit;
          _this2.noLeagueStatictics.periodTime = [{
            type: 'record',
            val: "".concat(periodParlayNoLeagueStatictics.win, "-").concat(periodParlayNoLeagueStatictics.lose, "-").concat(periodParlayNoLeagueStatictics.push),
            status: geStatus(periodParlayNoLeagueStatictics.win, periodParlayNoLeagueStatictics.lose)
          }, {
            type: 'pers',
            val: getPercent(periodParlayNoLeagueStatictics.win, periodParlayNoLeagueStatictics.lose),
            status: geStatus(getPercent(periodParlayNoLeagueStatictics.win, periodParlayNoLeagueStatictics.lose), periodParlayNoLeagueStatictics.win || periodParlayNoLeagueStatictics.lose ? 50 : 0)
          }, {
            type: 'roi',
            val: periodParlayNoLeagueStatictics.roi * 100,
            status: geStatus(periodParlayNoLeagueStatictics.roi * 100, 0)
          }, {
            type: 'winnings',
            val: periodParlayNoLeagueStatictics.profit,
            status: geStatus(periodParlayNoLeagueStatictics.profit, 0)
          }];
        } else {
          _this2.noLeagueStatictics.periodTime = [{
            type: 'record',
            val: '0-0-0',
            status: 'none'
          }, {
            type: 'pers',
            val: 0,
            status: 'none'
          }, {
            type: 'roi',
            val: 0,
            status: 'none'
          }, {
            type: 'winnings',
            val: 0,
            status: 'none'
          }];
        }

        if (overallParlayNoLeagueStatictics) {
          overallAllWin += overallParlayNoLeagueStatictics.win;
          overallAlllose += overallParlayNoLeagueStatictics.lose;
          overallAllPush += overallParlayNoLeagueStatictics.push;
          overallAllProfit += overallParlayNoLeagueStatictics.profit;
          _this2.noLeagueStatictics.allTime = [{
            type: 'record',
            val: "".concat(overallParlayNoLeagueStatictics.win, "-").concat(overallParlayNoLeagueStatictics.lose, "-").concat(overallParlayNoLeagueStatictics.push),
            status: geStatus(overallParlayNoLeagueStatictics.win, overallParlayNoLeagueStatictics.lose)
          }, {
            type: 'pers',
            val: getPercent(overallParlayNoLeagueStatictics.win, overallParlayNoLeagueStatictics.lose),
            status: geStatus(getPercent(overallParlayNoLeagueStatictics.win, overallParlayNoLeagueStatictics.lose), overallParlayNoLeagueStatictics.win || overallParlayNoLeagueStatictics.lose ? 50 : 0)
          }, {
            type: 'roi',
            val: overallParlayNoLeagueStatictics.roi * 100,
            status: geStatus(overallParlayNoLeagueStatictics.roi * 100, 0)
          }, {
            type: 'winnings',
            val: overallParlayNoLeagueStatictics.profit,
            status: geStatus(overallParlayNoLeagueStatictics.profit, 0)
          }];
        } else {
          _this2.noLeagueStatictics.allTime = [{
            type: 'record',
            val: '0-0-0',
            status: 'none'
          }, {
            type: 'pers',
            val: 0,
            status: 'none'
          }, {
            type: 'roi',
            val: 0,
            status: 'none'
          }, {
            type: 'winnings',
            val: 0,
            status: 'none'
          }];
        }

        _this2.hasNoLeagueStatictics = Boolean(periodParlayNoLeagueStatictics) || Boolean(overallParlayNoLeagueStatictics);
        _this2.statisticOverall = {
          periodTime: [{
            type: 'record',
            val: "".concat(overallPeriodWin, "-").concat(overallPeriodlose, "-").concat(overallPeriodPush),
            status: geStatus(overallPeriodWin, overallPeriodlose)
          }, {
            type: 'pers',
            val: getPercent(overallPeriodWin, overallPeriodlose),
            status: geStatus(getPercent(overallPeriodWin, overallPeriodlose), overallPeriodWin || overallPeriodlose ? 50 : 0)
          }, {
            type: 'roi',
            val: resp.periodRoi * 100,
            status: geStatus(resp.periodRoi * 100, 0)
          }, {
            type: 'winnings',
            val: overallPeriodProfit,
            status: geStatus(overallPeriodProfit, 0)
          }],
          allTime: [{
            type: 'record',
            val: "".concat(overallAllWin, "-").concat(overallAlllose, "-").concat(overallAllPush),
            status: geStatus(overallAllWin, overallAlllose)
          }, {
            type: 'pers',
            val: getPercent(overallAllWin, overallAlllose),
            status: geStatus(getPercent(overallAllWin, overallAlllose), overallAllWin || overallAlllose ? 50 : 0)
          }, {
            type: 'roi',
            val: resp.allTimeRoi * 100,
            status: geStatus(resp.allTimeRoi * 100, 0)
          }, {
            type: 'winnings',
            val: overallAllProfit,
            status: geStatus(overallAllProfit, 0)
          }]
        }; // statisticOverallWygerType mobile

        _this2.statisticOverallWygerType = _objectSpread(_objectSpread({}, _this2.statisticOverall), {}, {
          list: ['spread', 'moneyLine', 'total'].map(function (key) {
            var win_all = 0;
            var lose_all = 0;
            var push_all = 0;
            var roi_all = 0;
            var profit_all = 0;
            var win_period = 0;
            var lose_period = 0;
            var push_period = 0;
            var roi_period = 0;
            var profit_period = 0; // allTime

            var allTimeData = resp.overallWagerStatistics.find(function (z) {
              return z.wagerType === key;
            });

            if (allTimeData) {
              win_all = allTimeData.win;
              lose_all = allTimeData.lose;
              push_all = allTimeData.push;
              roi_all = allTimeData.roi;
              profit_all = allTimeData.profit;
            } //PeriodTime


            var periodTimeData = resp.periodWagerStatistics.find(function (z) {
              return z.wagerType === key;
            });

            if (periodTimeData) {
              win_period = periodTimeData.win;
              lose_period = periodTimeData.lose;
              push_period = periodTimeData.push;
              roi_period = periodTimeData.roi;
              profit_period = periodTimeData.profit;
            }

            var title = key.toLowerCase();
            return {
              title: title.charAt(0).toUpperCase() + title.slice(1),
              key: key,
              periodTime: [{
                type: 'record',
                val: "".concat(win_period, "-").concat(lose_period, "-").concat(push_period),
                status: geStatus(win_period, lose_period)
              }, {
                type: 'pers',
                val: getPercent(win_period, lose_period),
                status: geStatus(getPercent(win_period, lose_period), win_period || lose_period ? 50 : 0)
              }, {
                type: 'roi',
                val: roi_period * 100,
                status: geStatus(roi_period * 100, 0)
              }, {
                type: 'winnings',
                val: profit_period,
                status: geStatus(profit_period, 0)
              }],
              allTime: [{
                type: 'record',
                val: "".concat(win_all, "-").concat(lose_all, "-").concat(push_all),
                status: geStatus(win_all, lose_all)
              }, {
                type: 'pers',
                val: getPercent(win_all, lose_all),
                status: geStatus(getPercent(win_all, lose_all), win_all || lose_all ? 50 : 0)
              }, {
                type: 'roi',
                val: roi_all * 100,
                status: geStatus(roi_all * 100, 0)
              }, {
                type: 'winnings',
                val: profit_all,
                status: geStatus(profit_all, 0)
              }]
            };
          })
        }); // statisticOverallWygerType mobile (Parlay statistic)

        var overallParlayStatictics = resp.overallParlayStatictics;
        var periodParlayStatictics = resp.periodParlayStatictics;

        _this2.statisticOverallWygerType.list.push({
          title: 'Parlay',
          key: 'parlay',
          periodTime: [{
            type: 'record',
            val: periodParlayStatictics ? "".concat(periodParlayStatictics.win, "-").concat(periodParlayStatictics.lose, "-").concat(periodParlayStatictics.push) : "0-0-0",
            status: periodParlayStatictics ? geStatus(periodParlayStatictics.win, periodParlayStatictics.lose) : 'none'
          }, {
            type: 'pers',
            val: periodParlayStatictics ? getPercent(periodParlayStatictics.win, periodParlayStatictics.lose) : 0,
            status: periodParlayStatictics ? geStatus(getPercent(periodParlayStatictics.win, periodParlayStatictics.lose), periodParlayStatictics.win || periodParlayStatictics.lose ? 50 : 0) : 'none'
          }, {
            type: 'roi',
            val: periodParlayStatictics ? periodParlayStatictics.roi * 100 : 0,
            status: periodParlayStatictics ? geStatus(periodParlayStatictics.roi * 100, 0) : 'none'
          }, {
            type: 'winnings',
            val: periodParlayStatictics ? periodParlayStatictics.profit : 0,
            status: periodParlayStatictics ? geStatus(periodParlayStatictics.profit, 0) : 'none'
          }],
          allTime: [{
            type: 'record',
            val: overallParlayStatictics ? "".concat(overallParlayStatictics.win, "-").concat(overallParlayStatictics.lose, "-").concat(overallParlayStatictics.push) : "0-0-0",
            status: overallParlayStatictics ? geStatus(overallParlayStatictics.win, overallParlayStatictics.lose) : 'none'
          }, {
            type: 'pers',
            val: overallParlayStatictics ? getPercent(overallParlayStatictics.win, overallParlayStatictics.lose) : 0,
            status: overallParlayStatictics ? geStatus(getPercent(overallParlayStatictics.win, overallParlayStatictics.lose), overallParlayStatictics.win || overallParlayStatictics.lose ? 50 : 0) : 'none'
          }, {
            type: 'roi',
            val: overallParlayStatictics ? overallParlayStatictics.roi * 100 : 0,
            status: overallParlayStatictics ? geStatus(overallParlayStatictics.roi * 100, 0) : 'none'
          }, {
            type: 'winnings',
            val: overallParlayStatictics ? overallParlayStatictics.profit : 0,
            status: overallParlayStatictics ? geStatus(overallParlayStatictics.profit, 0) : 'none'
          }]
        });

        _this2.leagues = [].concat(leagues);
      });
    },
    fetchProfitData: function fetchProfitData() {
      var _this3 = this;

      var options = {
        from: this.dateFrom ? moment(this.dateFrom).toDate() : undefined,
        to: this.dateTo ? moment(this.dateTo).add(1, 'days').toDate() : undefined,
        league: this.leagueSelected,
        username: this.userName,
        parlaysOnly: this.parlaysOnlyState,
        wagerType: this.wagerTypeState,
        pickPaymentType: this.pickTypeState
      };
      profileClient.profitStats(options).then(function (resp) {
        var chartDates = [];
        var chartSeries = [];
        var isMobile = window.innerWidth < 1200;
        Object.keys(resp).forEach(function (key) {
          var data = resp[key];

          switch (data.scale) {
            case 'day':
              {
                if (isMobile) {
                  chartDates.push(moment(data.dateFrom).format('M/D'));
                } else {
                  chartDates.push(moment(data.dateFrom).format('MMM D YYYY'));
                }
              }
              break;

            case 'week':
              {
                if (isMobile) {
                  chartDates.push(moment(data.dateFrom).format('M/D'));
                } else {
                  chartDates.push(moment(data.dateFrom).format('MMM D YYYY'));
                }
              }
              break;

            case 'year':
              {
                if (isMobile) {
                  chartDates.push(moment(data.dateFrom).format('YYYY'));
                } else {
                  chartDates.push(moment(data.dateFrom).format('MMM D YYYY')); // chartDates.push(moment(data.dateFrom).format('YYYY'));
                }
              }
              break;

            default:
              {
                if (isMobile) {
                  chartDates.push(moment(data.dateFrom).format('M/D'));
                } else {
                  chartDates.push(moment(data.dateFrom).format('MMM D YYYY')); // chartDates.push(moment(data.dateFrom).format('MMMM YYYY'));
                }
              }
              break;
          }

          chartSeries.push(Number(data.profit).toFixed(0));
        });
        _this3.chartDates = [].concat(chartDates);
        _this3.chartSeries = [].concat(chartSeries);
      });
    },
    fetchResultativePeriod: function fetchResultativePeriod() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var timeList;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return profileClient.resultativePeriod({
                  username: _this4.userName
                });

              case 2:
                timeList = _context.sent;
                _this4.timeList = _toConsumableArray(timeList);

                if (_this4.period !== timeList[0].value) {
                  _this4.period = timeList[0].value;
                } else {
                  _this4.fetchData();
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    fetchData: function fetchData() {
      this.fetchStatisticData();
      this.fetchProfitData();
    },
    resetFilter: function resetFilter() {
      this.parlaysOnly = false;
      this.pickType = undefined;
      this.wagerType = undefined;
      this.parlaysOnlyState = false;
      this.pickTypeState = undefined;
      this.wagerTypeState = undefined;
      this.fetchData();
      this.filterIsOpen = false;
    },
    applyFilter: function applyFilter() {
      if (this.pickType !== this.pickTypeState || this.wagerType !== this.wagerTypeState || this.parlaysOnly !== this.parlaysOnlyState) {
        this.pickTypeState = this.pickType;
        this.wagerTypeState = this.wagerType;
        this.parlaysOnlyState = this.parlaysOnly;
        this.fetchData();
      }

      this.filterIsOpen = false;
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var timeList;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return profileClient.resultativePeriod({
                username: _this5.userName
              });

            case 2:
              timeList = _context2.sent;
              _this5.timeList = _toConsumableArray(timeList);
              _this5.period = timeList[0].value;

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};